module.exports = __webpack_public_path__ + "img/sert2.5fb6b6bb.png";